import { useCallback } from "react";

import { FeedbackType } from "../../../../API";
import { UpdateEventFeedbackInput } from "../../../../common/types/events/api";
import { EventViewModel } from "../../models/eventViewModel";
import FeedbackThumbs from "./FeedbackThumbs";

interface FeedbackThumbsTableCellContainerProps {
  event: EventViewModel;
  onUpdateEventFeedback: (input: UpdateEventFeedbackInput) => void;
}

const FeedbackThumbsTableCellContainer = ({
  event,
  onUpdateEventFeedback,
}: FeedbackThumbsTableCellContainerProps) => {
  const memoizedThumbUpClick = useCallback(() => {
    const input: UpdateEventFeedbackInput = {
      pk: event.customerId,
      sk: event.id,
      feedback: FeedbackType.POSITIVE,
      mitigatedRisk: null,
    };

    onUpdateEventFeedback(input);
  }, [event]);

  const memoizedThumbsDownClickCallback = useCallback(() => {
    const input: UpdateEventFeedbackInput = {
      pk: event.customerId,
      sk: event.id,
      feedback: FeedbackType.NEGATIVE,
      mitigatedRisk: null,
    };

    onUpdateEventFeedback(input);
  }, [event]);

  return (
    <FeedbackThumbs
      timestamp={event.timestamp}
      feedback={event.feedback}
      mitigatedRisk={event.mitigatedRisk}
      onThumbUpClick={memoizedThumbUpClick}
      onThumbsDownClick={memoizedThumbsDownClickCallback}
    />
  );
};

export default FeedbackThumbsTableCellContainer;
